import React from 'react';
import { AlertTriangle } from 'lucide-react';

export default function PushTip({ children, className = '', iconClass, strong = 'Atenção:' }) {
    return (
        <div className={`push-tip mt-4 mb-4 ${className}`}>
            {iconClass ? <i className={iconClass} aria-hidden="true"></i> : <AlertTriangle size={16} aria-hidden="true" />}
            <div><strong>{strong}</strong> {children}</div>
        </div>
    );
}
